import { entityApiPathMappings } from "../../mappers";
import { RydeUiUnit } from "../../models";

export const getBulkUpdatePath = (
  companyId: number,
  entity: RydeUiUnit,
): string =>
  `/api/v1/core/c/${companyId}/${entityApiPathMappings[entity]}/bulk/update`;
export const getBulkArchivePath = (
  companyId: number,
  entity: RydeUiUnit,
): string =>
  `/api/v1/core/c/${companyId}/${entityApiPathMappings[entity]}/bulk/archive`;
export const getBulkFindAreaPath = (
  companyId: number,
  entity: RydeUiUnit,
): string =>
  `/api/v1/core/c/${companyId}/${entityApiPathMappings[entity]}/bulk/find-area`;
export const getProcessesGetPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/processes`;
